/**
 * Utilidades comunes para todos los ejemplos
 */

// Verificar soporte de LoAF API
export function checkLoafSupport() {
  const supported = 'PerformanceLongAnimationFrameTiming' in window;

  if (!supported) {
    console.warn('⚠️ Long Animation Frames API no está soportada en este navegador');
    showBrowserWarning();
  }

  return supported;
}

// Mostrar advertencia en la UI
function showBrowserWarning() {
  const warning = document.createElement('div');
  warning.className = 'warning';
  warning.innerHTML = `
    <strong>⚠️ Navegador no compatible</strong>
    <p>Long Animation Frames API requiere Chrome/Edge 116 o superior.</p>
    <p>Actualmente estás usando: ${navigator.userAgent}</p>
  `;

  document.body.insertBefore(warning, document.body.firstChild);
}

// Logger mejorado para la consola
export class ConsoleLogger {
  constructor(outputElement) {
    this.outputElement = outputElement;
  }

  log(message, data = null) {
    const timestamp = new Date().toLocaleTimeString('es-ES', {
      hour12: false,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      fractionalSecondDigits: 3
    });

    const logMessage = `[${timestamp}] ${message}`;
    console.log(logMessage, data || '');

    if (this.outputElement) {
      const line = document.createElement('div');
      line.textContent = data ? `${logMessage} ${JSON.stringify(data, null, 2)}` : logMessage;
      this.outputElement.appendChild(line);
      this.outputElement.scrollTop = this.outputElement.scrollHeight;
    }
  }

  warn(message, data = null) {
    console.warn(message, data || '');
    if (this.outputElement) {
      const line = document.createElement('div');
      line.style.color = '#f57c00';
      line.textContent = `⚠️ ${message}`;
      this.outputElement.appendChild(line);
    }
  }

  error(message, data = null) {
    console.error(message, data || '');
    if (this.outputElement) {
      const line = document.createElement('div');
      line.style.color = '#d32f2f';
      line.textContent = `❌ ${message}`;
      this.outputElement.appendChild(line);
    }
  }

  clear() {
    if (this.outputElement) {
      this.outputElement.innerHTML = '';
    }
    console.clear();
  }
}

// Formatear duración en ms con colores
export function formatDuration(duration) {
  const rounded = Math.round(duration * 100) / 100;
  let className = 'good';

  if (duration > 200) {
    className = 'poor';
  } else if (duration > 100) {
    className = 'needs-improvement';
  }

  return `<span class="metric ${className}">${rounded}ms</span>`;
}

// Formatear entrada de LoAF para visualización
export function formatLoafEntry(entry) {
  return {
    duration: Math.round(entry.duration * 100) / 100,
    blockingDuration: Math.round(entry.blockingDuration * 100) / 100,
    renderStart: Math.round(entry.renderStart * 100) / 100,
    startTime: Math.round(entry.startTime * 100) / 100,
    scripts: entry.scripts.map(script => ({
      invoker: script.invoker,
      sourceURL: script.sourceURL,
      sourceFunctionName: script.sourceFunctionName,
      duration: Math.round(script.duration * 100) / 100,
      executionStart: Math.round(script.executionStart * 100) / 100,
      forcedStyleAndLayoutDuration: Math.round(script.forcedStyleAndLayoutDuration * 100) / 100
    }))
  };
}

// Determinar severidad de un frame
export function getFrameSeverity(blockingDuration) {
  if (blockingDuration > 200) return 'critical';
  if (blockingDuration > 100) return 'high';
  if (blockingDuration > 50) return 'medium';
  return 'low';
}

// Verificar si un script es de terceros
export function isThirdPartyScript(script) {
  if (!script.sourceURL) return false;

  try {
    const url = new URL(script.sourceURL, location.href);
    return url.hostname !== location.hostname;
  } catch {
    return false;
  }
}

// Simular tarea pesada (bloqueante)
export function heavyTask(duration = 100) {
  const start = performance.now();
  while (performance.now() - start < duration) {
    // Bloquear el main thread
    Math.random() * Math.random();
  }
}

// Simular layout thrashing
export function layoutThrashing(iterations = 100) {
  const element = document.createElement('div');
  element.style.position = 'absolute';
  element.style.left = '-9999px';
  document.body.appendChild(element);

  for (let i = 0; i < iterations; i++) {
    // Forzar layout al leer offsetHeight
    const height = element.offsetHeight;
    // Forzar style recalc al escribir
    element.style.width = `${height + i}px`;
  }

  document.body.removeChild(element);
}

// Inicialización común
checkLoafSupport();
